import * as React from 'react';
import { Button } from '@grandvisionhq/common';

const ActionButtons = ({ handleOnAction , handleOnCancel , isDisabled , labels ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "confirmation-modal__action-buttons"
    }, /*#__PURE__*/ React.createElement(Button, {
        "aria-label": labels.cancelButton,
        caption: labels.cancelButton,
        className: "confirmation-modal__action-button",
        "data-t": "confirmation-modal-cancel",
        onClick: handleOnCancel,
        size: "custom",
        variant: "outline"
    }), /*#__PURE__*/ React.createElement(Button, {
        "aria-label": labels.actionButton,
        caption: labels.actionButton,
        className: "confirmation-modal__action-button",
        "data-t": "confirmation-modal-confirm",
        onClick: handleOnAction,
        disabled: isDisabled,
        size: "custom"
    }))
;

export { ActionButtons };
//# sourceMappingURL=ActionButtons.js.map
